import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MemoModalMemoFragmentDoc } from './MemoModal.generated';
export type ChatPageHeaderMemoFragment = { __typename?: 'ChatRoomMemo', id: string, content: string, createdAt: TimeString };

export const ChatPageHeaderMemoFragmentDoc = gql`
    fragment ChatPageHeaderMemo on ChatRoomMemo {
  ...MemoModalMemo
}
    ${MemoModalMemoFragmentDoc}`;